import React, { createContext, useContext, useReducer, useState } from 'react';

// CONTEXT
const LogContext = createContext(null);
export const useLogContext = () => useContext(LogContext);

// REDUCER
export const reducer = (state, { type, name, key, ...action }) => {
  const log = state[name] || {};
  switch (type) {
    case 'LOAD':
      return {
        ...state,
        [name]: {
          ...log,
          [key]: action[key]
        }
      };
    case 'ERROR':
      return {
        ...state,
        [action.name]: {
          ...log,
          data: new Error(action.data)
        }
      };
    case 'FLUSH':
      return {};
    default:
      return state;
  }
};

// MAIN COMPONENT
export const logContext = Component => props => {

  // STATE
  const [ logs, updateLogs ] = useReducer(reducer, {});
  const [ activeLog, setActiveLog ] = useState();

  // RENDER
  return (
    <LogContext.Provider
      value={{
        logs,
        updateLogs,
        activeLog,
        setActiveLog
      }}
    >
      <Component {...props} />
    </LogContext.Provider>
  );
}
